import { RichText } from "../../../internal-components/RichText.js";
import { Card } from "../styles.js";

interface Props {
  text?: string;
}

const Page: React.FC<Props> = ({ text }) => {
  return (
    <Card>
      {text && <RichText dangerouslySetInnerHTML={{ __html: text }} />}
    </Card>
  );
};

export default Page;
